import axios from "axios"

const apiUrl = "/api/"

// --- HELPER-FUNKTIONEN (Annahme: diese sind in deinem Projekt zentral verfügbar) ---

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}) {
  if (!options.headers) {
    options.headers = {}
  }
  // Fügt automatisch den Auth-Token hinzu
  options.headers.Authorization = localStorage.getItem("token")
  return options
}

// --- API-DEFINITIONEN ---

export default {
  // Behalte deine bestehenden Module wie 'display'

  // --- NEUES SOCIAL-MODUL ---

  social: {
    getRequestsSummary() {
      return axios.get(buildUrl("social/requests/summary"), buildOptions()).then((res) => res.data)
    },

    // Erstellt eine neue Trainingsanfrage
    createTrainingRequest(requestData) {
      // requestData = { recipientId, postId, availability, message }
      return axios.post(buildUrl("social/training-requests"), requestData, buildOptions()).then((res) => res.data)
    },

    // Antwortet auf eine Trainingsanfrage
    respondToTrainingRequest(requestId, status) {
      // status = 'accepted' oder 'declined'
      return axios.put(buildUrl(`social/training-requests/${requestId}/respond`), { status }, buildOptions()).then((res) => res.data)
    },

    // Zieht eine gesendete Anfrage zurück
    withdrawTrainingRequest(requestId) {
      return axios.put(buildUrl(`social/training-requests/${requestId}/withdraw`), {}, buildOptions()).then((res) => res.data)
    },

    // Beendet eine Trainingspartnerschaft
    endTrainingPartnership(relationshipId) {
      return axios.put(buildUrl(`social/relationships/${relationshipId}/end-partnership`), {}, buildOptions()).then((res) => res.data)
    },
    /**
     * NEU: Startet oder beendet eine Trainingspartnerschaft für eine bestehende Freundschaft.
     * @param {string} relationshipId - Die ID der Freundschafts-Beziehung.
     * @param {string} action - Entweder 'start' oder 'end'.
     */
    updateTrainingPartnership(relationshipId, action) {
      const url = buildUrl(`social/relationship/${relationshipId}/training-partner`)
      // Die Aktion ('start' oder 'end') wird als Body des PUT-Requests gesendet.
      return axios.put(url, { action }, buildOptions()).then((res) => res.data)
    },
    /**
     * NEU: Holt alle Posts für eine bestimmte User-ID.
     */
    getUserPosts(userId) {
      const url = buildUrl(`social/posts/user/${userId}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    /**
     * NEU: Löscht einen eigenen Post (Soft Delete).
     */
    deletePost(postId) {
      const url = buildUrl(`social/post/${postId}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
    getSecureImage(identifier) {
      const url = buildUrl(`social/image/${identifier}`)
      const options = buildOptions({
        // WICHTIG: Sag axios, dass wir Binärdaten erwarten, keinen JSON-Text.
        responseType: "blob",
      })

      return axios.get(url, options).then((res) => res.data)
    },
    uploadImage(imageFile) {
      const url = buildUrl("social/upload/image")
      const formData = new FormData()

      // Der Key 'image' muss mit dem im Backend bei `upload.single('image')` übereinstimmen.
      formData.append("image", imageFile)

      const options = buildOptions({
        headers: {
          // Wichtig für Datei-Uploads!
          "Content-Type": "multipart/form-data",
        },
      })

      return axios.post(url, formData, options).then((res) => res.data)
    },
    getFriends(userId) {
      const url = buildUrl(`social/friends/${userId}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    // --- FEED ---
    getFeed() {
      const url = buildUrl("social/feed")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    // --- PROFIL ---
    getProfile(userId) {
      const url = buildUrl(`social/profile/${userId}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    updateMyProfile(profileData) {
      const url = buildUrl("social/profile")
      return axios.put(url, profileData, buildOptions()).then((res) => res.data)
    },
    getCheckedInUsers() {
      const url = buildUrl("social/checked-in")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    sendTrainingRequest(targetUserId) {
      const url = buildUrl(`social/request/training/${targetUserId}`)
      return axios.post(url, {}, buildOptions()).then((res) => res.data)
    },
    createPost(postData) {
      const url = buildUrl("social/post")
      return axios.post(url, postData, buildOptions()).then((res) => res.data)
    },
    // NEU: Route für Kurs-Anmeldungs-Post
    createCourseSignupPost(courseExecutionId) {
      const url = buildUrl("social/post/course-signup")
      return axios.post(url, { courseExecutionId }, buildOptions()).then((res) => res.data)
    },
    // NEU: Route für Kurs-Ankündigungs-Post (Instruktor)
    createCourseInstructingPost(data) {
      // { courseExecutionId, text }
      const url = buildUrl("social/post/course-instructing")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    // NEU: Like/Unlike eines Posts
    toggleLike(postId) {
      const url = buildUrl(`social/post/${postId}/like`)
      return axios.post(url, {}, buildOptions()).then((res) => res.data)
    },
    // NEU: Kommentar zu einem Post hinzufügen
    addComment(postId, text) {
      const url = buildUrl(`social/post/${postId}/comment`)
      return axios.post(url, { text }, buildOptions()).then((res) => res.data)
    },
    // NEU: Alle Kommentare für einen Post laden
    getComments(postId) {
      const url = buildUrl(`social/post/${postId}/comments`) // Annahme: Du erstellst diese Route im Backend
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    // --- SUCHE ---
    searchUsers(query) {
      const url = buildUrl("social/search")
      // Query-Parameter werden im 'params'-Objekt der Axios-Config übergeben
      const options = buildOptions({ params: { q: query } })
      return axios.get(url, options).then((res) => res.data)
    },

    // --- RELATIONSHIPS ---
    getFriendRequests() {
      const url = buildUrl("social/requests")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    sendFriendRequest(targetUserId) {
      const url = buildUrl(`social/request/${targetUserId}`)
      return axios.post(url, {}, buildOptions()).then((res) => res.data)
    },
    acceptRequest(relationshipId) {
      const url = buildUrl(`social/accept/${relationshipId}`)
      // PUT-Request ohne Body
      return axios.put(url, {}, buildOptions()).then((res) => res.data)
    },
    removeOrDeclineRelationship(relationshipId) {
      const url = buildUrl(`social/relationship/${relationshipId}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },

    // --- BLOCKIERUNG ---
    blockUser(targetUserId) {
      const url = buildUrl(`social/block/${targetUserId}`)
      return axios.post(url, {}, buildOptions()).then((res) => res.data)
    },
    unblockUser(relationshipId) {
      // Entblockieren ist dasselbe wie das Löschen der Beziehung
      const url = buildUrl(`social/relationship/${relationshipId}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },

    // --- MELDUNGEN & MODERATION ---
    // NEU: Post oder Profil melden
    reportItem(data) {
      // { itemId, itemType, reason }
      const url = buildUrl("social/report")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    // NEU: Posts zur Genehmigung abrufen (für Trainer)
    getPendingPosts() {
      const url = buildUrl("social/posts/pending")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    // NEU: Post genehmigen/ablehnen (für Trainer)
    reviewPost(postId, status) {
      // status = 'approved' or 'rejected'
      const url = buildUrl(`social/posts/review/${postId}`)
      return axios.put(url, { status }, buildOptions()).then((res) => res.data)
    },
  },
}
